export default __webpack_public_path__ + "static/media/1672.540c2042.png";